module.exports = __webpack_public_path__ + "static/img/digitalpeople1.4d450352.png";